function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import columnInfoGroup from './columnInfoGroup.js';
import mediaSection from './mediaSection.js';
import simpleDatalistSection from './simpleDatalistSection.js';
import callToActionsBlock from './callToActionsBlock.js';
import blockContent from '../fragments/blockContent.js';
var schema = defineObject('simpleContentSection', {
    variant: {
        title: 'Variant',
        type: 'string',
        options: {
            list: [
                'default',
                'medium'
            ]
        }
    },
    content: _object_spread({
        title: 'Content'
    }, blockContent.fragment)
}, [
    columnInfoGroup.schema.columnInfoGroup,
    mediaSection.schema.mediaSection,
    simpleDatalistSection.schema.simpleDatalistSection,
    callToActionsBlock.schema.callToActionsBlock
]);
var validator = z.object({
    content: blockContent.validator
}).partial();
schema.simpleContentSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=simpleContentSection.js.map